// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ng-0";
export var fileList = "_ng-2";
export var removeFileButton = "_ng-1";